import { render, staticRenderFns } from "./SupplierOnboardingAddress.vue?vue&type=template&id=6f37889b&"
import script from "./SupplierOnboardingAddress.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingAddress.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingAddress.vue?vue&type=style&index=0&id=6f37889b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports